import React from 'react';
import { motion } from 'framer-motion';
import './Contact.css';

const Contact = () => {
  const sectionVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <motion.section
      id="contact"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={sectionVariants}
    >
      <h2>Contact Me</h2>
      <div className="contact-links">
        <a href="https://discordapp.com/users/uzophh" className="contact-discord" target="_blank" rel="noopener noreferrer">
            <div className="discord-icon-wrapper">
              <img src="/discord-icon.png" alt="Discord Profile Link" className="discord-icon" />
            </div>
            <p>uzophh</p>
        </a>
        <a
          href="https://github.com/TheUzoph" 
          className="github-link contact-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/github-icon.png" alt="GitHub Profile Link" className="github-icon" />
          <p>Visit My GitHub</p>
        </a>
      </div>
    </motion.section>
  );
};

export default Contact;
